import React, {useEffect, useState} from 'react';
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Typography, Divider, TextField, InputAdornment, DialogActions, MenuItem, FormControlLabel, Checkbox
} from '@mui/material';
import AddBox from '@mui/icons-material/AddBox';
import CloseIcon from '@mui/icons-material/Close';
import {withStyles} from "@mui/styles";
import {Styles} from "../../../../config/design/styles";
import {EditOutlined} from "@mui/icons-material";
import Grid from "@mui/material/Grid2";
import {useSnackbar} from "notistack";
import LoadingButton from "../../../components/elements/LoadingButton";
import validator from "validator";
import axios from "axios";
import {defaultVariables} from "../../../../config";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import AppCardLoaderFields from "../../../components/loaders/AppCardLoaderFields";
import RayaField from "../../../components/elements/fields/RayaField";
import {Pencil} from "lucide-react";
import {currencySymbol} from "../../../../config/values";
import NumberField from "../../../components/elements/fields/NumberField";
import {industries} from "../../../../config/Permissions";
import moment from "moment/moment";

const MakeDiscountCodeButton = ({ disabled, classes,item_id,industry_id,reload }) => {
    const [open, setOpen] = useState(false);
    const navigation = useNavigate();
    const { t } = useTranslation();

    const initFields = {
        code: '',
        type: 'fixed',
        amount: '',
        free_delivery: 0,
        for_first_order: 0,
        valid_until: " ",
        quantity: '',
        minimum_order: '',
        industry: 'all',
    };
    const [fields, setFields] = useState(initFields);
    const [data, setData] = useState(null);
    const [errors, setErrors] = useState({});
    const [submitLoading, setSubmitLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const loginToken = localStorage.getItem('ACT');
    const loadData = async () =>{
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        }
        await setLoading(true);
        await axios.get(`${defaultVariables.url}/discount-codes/get/${item_id}`,config)
            .then(response => {
                let fields = {
                    code: response.data.code,
                    type: response.data.type,
                    amount: response.data.amount,
                    minimum_order: response.data.minimum_order,
                    free_delivery: response.data.free_delivery,
                    for_first_order: response.data.for_first_order,
                    valid_until:  !!response.data.valid_until ?  moment(response.data.valid_until).format("YYYY-MM-DD") : " ",
                    quantity:  response.data.quantity,
                    industry:  !!response.data.industry ? response.data.industry : 'all',
                }
                setFields(fields);
                setData(response.data);
                setLoading(false);
            })
            .catch(error => {
                console.error("Error fetching match data:", error);
                setLoading(false);
            });
    }

    useEffect(() => {
        if(!!item_id && !!open)  loadData();
    }, [item_id,open]);
    useEffect(() => {

    }, [industry_id]);
    
    const handleChange = (e) => {
        let { name, value } = e.target;
        setFields((prevFields) => ({ ...prevFields, [name]: value }));
        setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
    };
    const handleField = (input,val) => {
        setFields((prevFields) => ({ ...prevFields, [input] : val }));
        setErrors((prevErrors) => ({ ...prevErrors, [input]: '' }));
    };
    const resetFields = () => {
        setFields(initFields);
    }
    const closeDialog = () => {
        setOpen(false);
        if(!item_id){
            setTimeout(() => {
                resetFields();
            }, 300);
        }
    }
    const handleValidation = async (callback) => {
        let formIsValid = true;
        let newErrors = {};

        // Validation for full_name
        if (validator.isEmpty(fields.code)) {
            formIsValid = false;
            newErrors.code = t('emptyField');
        }
        // Validation for full_name
        if (!fields.amount) {
            formIsValid = false;
            newErrors.amount = t('emptyField');
        }
        if(fields.type === "percent"){
            if(fields.amount < 1 || fields.amount > 99){
                formIsValid = false;
                newErrors.amount = t('wrongPercent');
            }
        }

        setErrors(newErrors);
        if (!formIsValid) setSubmitLoading(false);
        callback(formIsValid);
    };

    const handleRequest = async () => {

        const data = new FormData();

        data.append('code', fields.code);
        data.append('type', fields.type);
        data.append('amount', fields.amount);
        data.append('minimum_order', fields.minimum_order);
        data.append('free_delivery', !!fields.free_delivery ? 1 : 0);
        data.append('for_first_order', !!fields.for_first_order ? 1 : 0);
        data.append('valid_until', fields.valid_until);
        data.append('quantity', fields.quantity);
        if(!!item_id){
            data.append('item_id', item_id);
        }
        if(fields.industry !== "all"){
            data.append('industry', fields.industry);
        }

        const loginToken = localStorage.getItem('ACT');
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };

        try {
            const response = await axios.post(`${defaultVariables.url}/discount-codes/make`, data, config);
            reload();
            setSubmitLoading(false);
            closeDialog();
            enqueueSnackbar(t('detailsSet'), { variant: 'success' });

        } catch (error) {
            console.error(error.response);
            setSubmitLoading(false);
            if(error.response.status === 403){
                enqueueSnackbar(t('duplicateItemName'), { variant: 'warning' });
            }else{
                enqueueSnackbar(t('detailsSetFailed'), { variant: 'error' });

            }
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitLoading(true);
        handleValidation((valid) => {
            if (valid) handleRequest();
        });
    };
    return (
        <>
            {
                !item_id ?
                    <Button
                        disabled={disabled}
                        variant={!!item_id ? "contained" : "contained"}
                        color="secondary"
                        startIcon={!!item_id ? <Pencil className="lucide-icon-secondary btn"/> : <AddBox/>}

                        onClick={() => setOpen(!open)}
                        //className={!!item_id ? "editItemBtn" : "addItemBtn"}
                    >
                        {t(!!item_id ? "editDiscountCode" : 'addDiscountCode')}
                    </Button>
                    :
                    <Button
                        disabled={disabled}
                        variant="outlined"
                        color="secondary"
                        onClick={() => setOpen(!open)}
                        startIcon={!!item_id ? <Pencil className="lucide-icon-secondary btn"/> : <AddBox/>}
                    >
                        {t(!!item_id ? "edit" : 'addDiscountCode')}
                    </Button>
             }


            <Dialog
                fullWidth
                maxWidth={'sm'}
                open={open}
                onClose={() => closeDialog()}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title">
                    {t(!!item_id ? "editDiscountCode" : 'addDiscountCode')}
                    <IconButton aria-label="close" className={classes.dialogClose} onClick={() => closeDialog()}>
                        <CloseIcon/>
                    </IconButton>
                </DialogTitle>
                <Divider/>
                <DialogContent className="dialog-add-match">
                    <Grid container spacing={2}>
                        {
                            !!loading ?
                                <Grid item size={12}>
                                    <AppCardLoaderFields height={300}/>
                                </Grid>
                                    :
                                <>
                                    <Grid item size={{xs: 12}}>
                                        <RayaField
                                            variant="outlined"
                                            required
                                            fullWidth
                                            label={t('discountCode')}
                                            name="code"
                                            value={fields.code}
                                            onChange={handleChange}
                                            error={!!errors.code}
                                            helperText={errors.code}
                                            disabled={!!item_id}
                                        />
                                    </Grid>
                                    <Grid item size={{xs: 12,md:6}}>
                                        <RayaField
                                            variant="outlined"
                                            required
                                            fullWidth
                                            label={t('discountType')}
                                            name="type"
                                            value={fields.type}
                                            onChange={handleChange}
                                            error={!!errors.type}
                                            helperText={errors.type}
                                            select
                                        >
                                            <MenuItem value="percent">{t('percent')}</MenuItem>
                                            <MenuItem value="fixed">{t('fixedPrice')}</MenuItem>
                                        </RayaField>
                                    </Grid>
                                    <Grid item size={{xs:12, md:6}}>
                                        <NumberField
                                            fullWidth
                                            label={t('amount')}
                                            variant="outlined"
                                            value={fields.amount}
                                            endAdornment={fields.type === "fixed" ? currencySymbol  : "%"}
                                            decimals={2}
                                            min={0}
                                            onChange={(res) => handleField('amount', res)}
                                            error={!!errors.amount}
                                            helperText={errors.amount}
                                        />
                                    </Grid>
                                    <Grid item size={{xs:12, md:6}}>
                                        <NumberField
                                            fullWidth
                                            label={t('numberOfQuantityForDiscount')}
                                            variant="outlined"
                                            value={fields.quantity}
                                            decimals={0}
                                            min={0}
                                            onChange={(res) => handleField('quantity', res)}
                                            error={!!errors.quantity}
                                            helperText={errors.quantity}
                                        />
                                    </Grid>
                                    <Grid item size={{xs:12, md:6}}>
                                        <NumberField
                                            fullWidth
                                            label={t('minimumOrderAmountCode')}
                                            variant="outlined"
                                            value={fields.minimum_order}
                                            endAdornment={currencySymbol}
                                            decimals={2}
                                            min={0}
                                            onChange={(res) => handleField('minimum_order', res)}
                                            error={!!errors.minimum_order}
                                            helperText={errors.minimum_order}
                                        />
                                    </Grid>
                                    <Grid item size={{xs:12, md:6}}>
                                        <RayaField
                                            fullWidth
                                            optional
                                            variant="outlined"
                                            value={fields.valid_until}
                                            label={t('valid_until')}
                                            name="valid_until"
                                            type="date"
                                            onChange={handleChange}
                                            error={!!errors['valid_until']}
                                            helperText={errors['valid_until']}
                                        />
                                    </Grid>
                                    <Grid item size={{xs:12,md:6}}>
                                        <RayaField
                                            variant="outlined"
                                            required
                                            fullWidth
                                            label={t('industry')}
                                            name="industry"
                                            value={fields.industry}
                                            onChange={handleChange}
                                            error={!!errors.industry}
                                            helperText={errors.industry}
                                            select
                                        >
                                            <MenuItem value={"all"}>{t("all")}</MenuItem>
                                            {
                                                industries.map((industry,index) =>(
                                                    <MenuItem key={index} value={industry}>{t(industry)}</MenuItem>
                                                ))
                                            }
                                        </RayaField>
                                    </Grid>
                                    <Grid item size={{ xs:12, md:6 }}>
                                        <FormControlLabel
                                            label={t('free_delivery_code')}
                                            control={<Checkbox checked={fields.free_delivery} onChange={() => handleField('free_delivery', !fields.free_delivery)} />}
                                        />
                                    </Grid>
                                    <Grid item size={{ xs:12, md:6 }}>
                                        <FormControlLabel
                                            label={t('for_first_order')}
                                            control={<Checkbox checked={fields.for_first_order} onChange={() => handleField('for_first_order', !fields.for_first_order)} />}
                                        />
                                    </Grid>
                                </>
                        }

                    </Grid>
                </DialogContent>
                <DialogActions style={{display:"flex",justifyContent:"center"}}>
                        <LoadingButton
                            variant="contained"
                            color="primary"
                            onClick={handleSubmit}
                            loading={submitLoading}
                        >
                            {t('setDetails')}
                        </LoadingButton>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default withStyles(Styles)(MakeDiscountCodeButton);
